import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../store';
import { setStoreId, setZipCode } from '../store/app';
import { getAppState } from '../store/app/selectors';
import { setCookieStoreId } from '../utils/cookieInformation';
import { sendInsightsEvent } from '../utils/insights/sendInsights';
const useMenu = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const { zipCode } = useSelector(getAppState);
    const dispatch = useAppDispatch();
    const openMenu = () => {
        setIsMenuOpen(true);
    };
    const closeMenu = () => {
        setIsMenuOpen(false);
    };
    const onZipCodeChange = (zipCode) => {
        dispatch(setZipCode(zipCode ?? ''));
    };
    const onStoreChange = (storeId, dexfAppSettings) => {
        dispatch(setStoreId(storeId ?? ''));
        setCookieStoreId(dexfAppSettings, storeId);
        sendInsightsEvent('showMe', 'set_store_location');
    };
    return {
        isMenuOpen,
        zipCode,
        openMenu,
        closeMenu,
        onZipCodeChange,
        onStoreChange
    };
};
export default useMenu;
//# sourceMappingURL=useMenu.js.map